import { DebtList } from 'src/pages/finSystem/debt/list/DebtList'

export const DebtPage = () => {
  return <DebtList />
}
